/**
 * Buy Box V3 - One-Time Purchase Only
 * Fully independent from Buy Box V2. All selectors use ".buy-box-v3".
 *
 * FUNCTIONALITY:
 * - Gallery navigation (arrows, thumbnails, swipe, keyboard)
 * - Add to cart (one-time only, no selling plans)
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.buy-box-v3').forEach(initBuyBoxV3);
  });

  function initBuyBoxV3(container) {
    initGallery(container);
    initCart(container);
    initSocialProofScroll(container);
  }

  function initSocialProofScroll(container) {
    var socialProof = container.querySelector('.buy-box-v3__social-proof--clickable');
    if (!socialProof) return;

    var reviewsId = socialProof.dataset.reviewsId;
    if (!reviewsId) return;

    socialProof.addEventListener('click', function(e) {
      e.preventDefault();
      var reviewsElement = document.getElementById(reviewsId);
      if (reviewsElement) {
        reviewsElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initGallery(container) {
    var gallery = container.querySelector('.buy-box-v3__gallery');
    if (!gallery) return;

    var images = gallery.querySelectorAll('.buy-box-v3__gallery-image');
    var thumbnails = gallery.querySelectorAll('.buy-box-v3__thumbnail');
    var prevBtn = gallery.querySelector('.buy-box-v3__gallery-arrow--prev');
    var nextBtn = gallery.querySelector('.buy-box-v3__gallery-arrow--next');
    var counter = gallery.querySelector('.buy-box-v3__gallery-current');

    if (images.length === 0) return;

    var currentIndex = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;

      currentIndex = index;

      images.forEach(function(img, i) {
        img.classList.toggle('buy-box-v3__gallery-image--active', i === currentIndex);
      });

      thumbnails.forEach(function(thumb, i) {
        thumb.classList.toggle('buy-box-v3__thumbnail--active', i === currentIndex);
      });

      if (counter) {
        counter.textContent = currentIndex + 1;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showImage(currentIndex + 1);
      });
    }

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        var index = parseInt(this.dataset.index, 10);
        showImage(index);
      });
    });

    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    var touchStartX = 0;
    var touchEndX = 0;

    var galleryMain = gallery.querySelector('.buy-box-v3__gallery-main');
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      galleryMain.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          showImage(diff > 0 ? currentIndex + 1 : currentIndex - 1);
        }
      }, { passive: true });
    }
  }

  function initCart(container) {
    var primaryCta = container.querySelector('.buy-box-v3__cta--primary');
    var variantId = container.dataset.variantId;

    if (!primaryCta) return;

    primaryCta.addEventListener('click', function(e) {
      e.preventDefault();

      if (variantId) {
        addToCart(variantId, 1, container);
      } else {
        console.error('Buy Box V3: No variant ID found');
      }
    });
  }

  function addToCart(variantId, quantity, container) {
    if (!variantId) {
      console.error('Buy Box V3: No variant ID provided');
      return;
    }

    var formData = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: quantity
      }]
    };

    // Loading state scoped to this V3 instance
    var ctaButtons = container.querySelectorAll('.buy-box-v3__cta');
    ctaButtons.forEach(function(btn) {
      btn.classList.add('buy-box-v3__cta--loading');
      btn.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.message || err.description || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(function(data) {
      console.log('Buy Box V3: Added to cart', data);

      ctaButtons.forEach(function(btn) {
        btn.classList.remove('buy-box-v3__cta--loading');
        btn.disabled = false;
      });

      openCartDrawer();
    })
    .catch(function(error) {
      console.error('Buy Box V3: Error adding to cart', error);

      ctaButtons.forEach(function(btn) {
        btn.classList.remove('buy-box-v3__cta--loading');
        btn.disabled = false;
      });

      alert('Error: ' + error.message);
    });
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));

    var cartTriggers = [
      '[data-cart-trigger]',
      '.js-cart-trigger',
      '.cart-icon',
      '[data-action="open-drawer"][data-drawer="cart"]',
      '#cart-icon',
      '.header__icon--cart',
      '[href="/cart"]'
    ];

    var drawerOpened = false;

    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger && typeof trigger.click === 'function') {
        var isDrawerTrigger =
          trigger.hasAttribute('data-cart-trigger') ||
          trigger.hasAttribute('data-action') ||
          trigger.classList.contains('js-cart-trigger');

        if (isDrawerTrigger) {
          trigger.click();
          drawerOpened = true;
          break;
        }
      }
    }

    var drawerSelectors = [
      '.cart-drawer', '#cart-drawer', '.drawer--cart',
      '[data-drawer="cart"]', '.mini-cart', '.cart-flyout'
    ];

    for (var j = 0; j < drawerSelectors.length; j++) {
      var drawer = document.querySelector(drawerSelectors[j]);
      if (drawer) {
        drawer.classList.add('is-open', 'active', 'open');
        drawerOpened = true;
        var overlay = document.querySelector('.drawer-overlay, .cart-overlay');
        if (overlay) overlay.classList.add('is-open', 'active');
        break;
      }
    }

    if (!drawerOpened) {
      setTimeout(function() {
        var visibleDrawer = document.querySelector('.cart-drawer.is-open, .drawer--cart.active, [data-drawer="cart"].open');
        if (!visibleDrawer) window.location.href = '/cart';
      }, 300);
    }
  }

})();
